export interface Match {
  id: number;
  league: string;
  homeTeam: string;
  awayTeam: string;
  homeScore?: number;
  awayScore?: number;
  time: string;
  status: "live" | "upcoming" | "finished";
  category: string;
  viewers?: number;
}

export interface CategoryData {
  slug: string;
  name: string;
  description: string;
  icon: string;
  matches: Match[];
}

export const categoriesData: CategoryData[] = [
  {
    slug: "football",
    name: "足球",
    description: "全球顶级足球赛事竞猜，英超、西甲、意甲、德甲、欧冠、世界杯等全覆盖，实时赔率更新",
    icon: "ri-football-line",
    matches: [
      { id: 101, league: "英超联赛", homeTeam: "曼联", awayTeam: "利物浦", homeScore: 2, awayScore: 1, time: "78'", status: "live", category: "football", viewers: 128500 },
      { id: 102, league: "西甲联赛", homeTeam: "皇家马德里", awayTeam: "巴塞罗那", homeScore: 1, awayScore: 1, time: "65'", status: "live", category: "football", viewers: 215000 },
      { id: 103, league: "中超联赛", homeTeam: "上海海港", awayTeam: "北京国安", time: "2026-08-09 19:35", status: "upcoming", category: "football" },
      { id: 104, league: "意甲联赛", homeTeam: "AC米兰", awayTeam: "国际米兰", time: "2026-08-10 03:00", status: "upcoming", category: "football" },
      { id: 105, league: "欧冠联赛", homeTeam: "曼城", awayTeam: "拜仁慕尼黑", homeScore: 3, awayScore: 2, time: "全场", status: "finished", category: "football" },
      { id: 106, league: "德甲联赛", homeTeam: "多特蒙德", awayTeam: "勒沃库森", homeScore: 0, awayScore: 0, time: "全场", status: "finished", category: "football" },
      { id: 107, league: "法甲联赛", homeTeam: "巴黎圣日耳曼", awayTeam: "马赛", time: "2026-08-11 04:00", status: "upcoming", category: "football" },
      { id: 108, league: "世界杯预选赛", homeTeam: "日本", awayTeam: "韩国", time: "2026-08-12 18:00", status: "upcoming", category: "football" },
    ],
  },
  {
    slug: "basketball",
    name: "篮球",
    description: "NBA、CBA、欧洲篮球联赛等全球顶级篮球赛事竞猜，实时比分同步，专业数据分析",
    icon: "ri-basketball-line",
    matches: [
      { id: 201, league: "NBA常规赛", homeTeam: "洛杉矶湖人", awayTeam: "金州勇士", homeScore: 98, awayScore: 102, time: "Q4 3:25", status: "live", category: "basketball", viewers: 95300 },
      { id: 202, league: "NBA常规赛", homeTeam: "波士顿凯尔特人", awayTeam: "密尔沃基雄鹿", time: "2026-08-09 08:00", status: "upcoming", category: "basketball" },
      { id: 203, league: "CBA联赛", homeTeam: "广东宏远", awayTeam: "辽宁本钢", time: "2026-08-09 19:35", status: "upcoming", category: "basketball" },
      { id: 204, league: "NBA常规赛", homeTeam: "丹佛掘金", awayTeam: "菲尼克斯太阳", homeScore: 115, awayScore: 108, time: "全场", status: "finished", category: "basketball" },
      { id: 205, league: "欧洲篮球联赛", homeTeam: "皇家马德里", awayTeam: "费内巴切", time: "2026-08-10 02:30", status: "upcoming", category: "basketball" },
      { id: 206, league: "NBA季后赛", homeTeam: "迈阿密热火", awayTeam: "纽约尼克斯", homeScore: 88, awayScore: 92, time: "全场", status: "finished", category: "basketball" },
    ],
  },
  {
    slug: "esports",
    name: "电竞",
    description: "LOL、DOTA2、CS:GO、王者荣耀等热门电竞项目赛事竞猜，实时数据同步，极速结算",
    icon: "ri-gamepad-line",
    matches: [
      { id: 301, league: "LPL夏季赛", homeTeam: "JDG", awayTeam: "BLG", homeScore: 2, awayScore: 1, time: "BO5 G4", status: "live", category: "esports", viewers: 212000 },
      { id: 302, league: "DOTA2国际邀请赛", homeTeam: "Team Spirit", awayTeam: "PSG.LGD", time: "2026-08-10 14:00", status: "upcoming", category: "esports" },
      { id: 303, league: "CS:GO Major", homeTeam: "FaZe Clan", awayTeam: "NAVI", time: "2026-08-11 20:00", status: "upcoming", category: "esports" },
      { id: 304, league: "王者荣耀KPL", homeTeam: "成都AG超玩会", awayTeam: "重庆狼队", homeScore: 3, awayScore: 1, time: "全场", status: "finished", category: "esports" },
      { id: 305, league: "LCK夏季赛", homeTeam: "T1", awayTeam: "Gen.G", homeScore: 1, awayScore: 1, time: "BO3 G2", status: "live", category: "esports", viewers: 189000 },
    ],
  },
  {
    slug: "tennis",
    name: "网球",
    description: "大满贯、ATP、WTA巡回赛等顶级网球赛事竞猜，专业数据模型支持，实时赔率分析",
    icon: "ri-base-station-line",
    matches: [
      { id: 401, league: "法网公开赛", homeTeam: "阿尔卡拉斯", awayTeam: "德约科维奇", homeScore: 2, awayScore: 1, time: "Set 4", status: "live", category: "tennis", viewers: 67400 },
      { id: 402, league: "ATP大师赛", homeTeam: "辛纳", awayTeam: "兹维列夫", time: "2026-08-10 20:00", status: "upcoming", category: "tennis" },
      { id: 403, league: "WTA巡回赛", homeTeam: "斯瓦泰克", awayTeam: "萨巴伦卡", time: "2026-08-11 16:00", status: "upcoming", category: "tennis" },
      { id: 404, league: "温网公开赛", homeTeam: "梅德韦杰夫", awayTeam: "鲁德", homeScore: 3, awayScore: 0, time: "全场", status: "finished", category: "tennis" },
    ],
  },
  {
    slug: "comprehensive",
    name: "综合",
    description: "乒乓球、羽毛球、排球、F1赛车、拳击、斯诺克等综合体育赛事全覆盖",
    icon: "ri-medal-line",
    matches: [
      { id: 501, league: "世界乒乓球锦标赛", homeTeam: "樊振东", awayTeam: "马龙", homeScore: 3, awayScore: 2, time: "Set 5", status: "live", category: "comprehensive", viewers: 45200 },
      { id: 502, league: "F1大奖赛", homeTeam: "维斯塔潘", awayTeam: "汉密尔顿", time: "2026-08-10 21:00", status: "upcoming", category: "comprehensive" },
      { id: 503, league: "世界羽毛球锦标赛", homeTeam: "安赛龙", awayTeam: "李梓嘉", time: "2026-08-12 15:00", status: "upcoming", category: "comprehensive" },
      { id: 504, league: "世界拳王争霸赛", homeTeam: "泰森·富里", awayTeam: "乌西克", homeScore: 0, awayScore: 0, time: "R8", status: "live", category: "comprehensive", viewers: 321000 },
      { id: 505, league: "斯诺克大师赛", homeTeam: "奥沙利文", awayTeam: "特鲁姆普", homeScore: 6, awayScore: 4, time: "全场", status: "finished", category: "comprehensive" },
    ],
  },
];